import { createModel } from "xstate/lib/model";
import { ICity, IStreet } from "@nju/data-access-portal-wwt";
import { IContext } from "./context";

export const model = createModel(
  {
    // eslint-disable-next-line unicorn/no-null
    city: null,
    // eslint-disable-next-line unicorn/no-null
    street: null,
    withoutStreet: false,
    houseNumber: "",
    apartmentNumber: "",
    errorCode: "",
  } as IContext,
  {
    events: {
      setCity: (value: ICity | undefined) => {
        return { value };
      },
      setStreet: (value: IStreet | undefined) => {
        return { value };
      },
      setWithoutStreet: (value: boolean) => {
        return { value };
      },
      setHouseNumber: (value: string) => {
        return { value };
      },
      setApartmentNumber: (value: string) => {
        return { value };
      },
      setApartmentNumberError: () => {
        return {};
      },
      verify: () => {
        return {};
      },
      missingCity: () => {
        return {};
      },
      addressVerified: (
        cityId: number,
        cityName: string,
        houseNumber: string,
        apartmentNumber: string,
        installationToken: string,
        streetId?: number,
        streetName?: string,
      ) => {
        return {
          cityId,
          cityName,
          streetId,
          streetName,
          houseNumber,
          apartmentNumber,
          installationToken,
        };
      },
      addressNotVerified: (errorCode: string | number) => {
        return { errorCode };
      },
    },
  },
);

export const validate = model.assign((context) => {
  let cityError: string | undefined;
  let streetError: string | undefined;
  let houseNumberError: string | undefined;
  let apartmentNumberError: string | undefined;

  if (!context.city) {
    cityError = "Wpisz miejscowość.";
  }

  const isStreetDisabled = context.withoutStreet || !context.city;

  if (!context.withoutStreet && !context.street && !isStreetDisabled) {
    streetError = "Wpisz ulicę.";
  }

  const isHouseNumberDisabled = context.withoutStreet
    ? !context.city
    : !context.street;

  if (!context.houseNumber && !isHouseNumberDisabled) {
    houseNumberError = "Wpisz nr domu.";
  }

  if (context.houseNumber.length > 8) {
    houseNumberError = "Nr jest za długi.";
  }

  if (context.apartmentNumber.length > 8) {
    apartmentNumberError = "Nr jest za długi.";
  }

  return {
    cityError,
    streetError,
    houseNumberError,
    apartmentNumberError,
  };
});

export const setCity = model.assign((_, event) => {
  return {
    city: event.value,
    cityError: undefined,
    street: undefined,
    houseNumber: "",
    apartmentNumber: "",
  };
}, "setCity");

export const setStreet = model.assign((_, event) => {
  return {
    street: event.value,
    streetError: undefined,
    houseNumber: "",
    apartmentNumber: "",
  };
}, "setStreet");

export const setWithoutStreet = model.assign((_, event) => {
  return {
    street: undefined,
    withoutStreet: event.value,
    streetError: undefined,
    houseNumberError: undefined,
    apartmentNumberError: undefined,
    houseNumber: "",
    apartmentNumber: "",
  };
}, "setWithoutStreet");

export const setHouseNumber = model.assign((_, event) => {
  return {
    houseNumber: event.value,
    houseNumberError: undefined,
    apartmentNumberError: undefined,
    apartmentNumber: "",
  };
}, "setHouseNumber");

export const setApartmentNumber = model.assign((_, event) => {
  return {
    apartmentNumber: event.value,
    apartmentNumberError: undefined,
  };
}, "setApartmentNumber");

export const setApartmentNumberError = model.assign(() => {
  return {
    apartmentNumberError: "Wpisz nr lokalu.",
  };
}, "setApartmentNumberError");

export const clearFormError = model.assign(() => {
  return {
    formError: undefined,
  };
});
